var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29303 5.293C5.48056 5.10553 5.73487 5.00021 6.00003 5.00021C6.26519 5.00021 6.5195 5.10553 6.70703 5.293L12 10.586L17.293 5.293C17.3853 5.19749 17.4956 5.1213 17.6176 5.0689C17.7396 5.01649 17.8709 4.9889 18.0036 4.98775C18.1364 4.98659 18.2681 5.01189 18.391 5.06218C18.5139 5.11246 18.6255 5.18671 18.7194 5.2806C18.8133 5.37449 18.8876 5.48615 18.9379 5.60904C18.9881 5.73194 19.0134 5.86362 19.0123 5.9964C19.0111 6.12918 18.9835 6.2604 18.9311 6.3824C18.8787 6.50441 18.8025 6.61475 18.707 6.707L13.414 12L18.707 17.293C18.8892 17.4816 18.99 17.7342 18.9877 17.9964C18.9854 18.2586 18.8803 18.5094 18.6948 18.6948C18.5094 18.8802 18.2586 18.9854 17.9964 18.9877C17.7342 18.99 17.4816 18.8892 17.293 18.707L12 13.414L6.70703 18.707C6.51843 18.8892 6.26583 18.99 6.00363 18.9877C5.74143 18.9854 5.49062 18.8802 5.30521 18.6948C5.1198 18.5094 5.01463 18.2586 5.01236 17.9964C5.01008 17.7342 5.11087 17.4816 5.29303 17.293L10.586 12L5.29303 6.707C5.10556 6.51947 5.00024 6.26516 5.00024 6C5.00024 5.73483 5.10556 5.48053 5.29303 5.293Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.846fb18cf811f80a746e458cd761d8d6.svg";
export { ForwardRef as ReactComponent };